import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.css']
})
export class ClientsComponent implements OnInit {

  testimonials = [{
    logo: 'assets/images/mock-logo-4.png',
    photo: 'assets/images/face-1.jpg',
    text: "He intentado usar diferentes softwares. La computadora no es mi lado fuerte. Hay un excelente soporte detrás de ArgoApps y personas que lo guiarán a través de él. Si tiene alguna pregunta, la analizarán y le explicarán cómo hacerlo.",
    title: 'Jhon Rodríguez',
    subtitle: 'Product Manager - Latencia Activa'
  }, {
    logo: 'assets/images/mock-logo-2.png',
    photo: 'assets/images/face-2.jpg',
    text: "Definitivamente los recomiendo 100 x 100. Son una empresa confiable con ideas muy buenas para la gestión de datos. Me ayudaron a hacer una gestión de datos precisa y ágil que a su vez me ayudó a tomar la mejor decisión para mi negocio.",
    title: 'Olger Zuñiga',
    subtitle: 'Jefe de Mercadeo - Infoprefa CR'
  }, 
  {
    logo: 'assets/images/mock-logo-3.png',
    photo: 'assets/images/face-3.jpg',
    text: "Los contacté para ver si era posible plasmar una idea que tenía para una aplicación móvil. No solo llevaron acabo la aplicación y todo su desarrollo sino que también impletaron funciones extra que ahora son imprescindibles para nosotros.",
    title: 'Jaime Solera',
    subtitle: 'Emprendedor - BuscoCasa CR'
  },
  {
    logo: 'assets/images/mock-logo-3.png',
    photo: 'assets/images/face-3.jpg',
    text: "Desde hace más de 2 años hemos trabajado con aplicaciones  hechas por ArgoApps,  las mismas son ágiles y amigables, rápidamente se puede encontrar la información necesaria, generando los reportes y cotizaciones deseados.   Cuando hemos necesitado mejoras y servicios adicionales los hemos recibido en forma muy eficiente.",
    title: 'Ing. Oscar Campos',
    subtitle: 'Importaciones Campos Rudin'
  }
]

  constructor() { }

  ngOnInit(): void {
  }

  // carousel option
  testimonialOptions: OwlOptions = {
    loop: true,
    autoplay:true,
    responsive: {
      0: {
        items: 1
      },
      576: {
        items: 2
      },
    },
    nav: true,
  };
}
